<div class="group">
    <div class="title" [ngClass]="titleClass" (click)="toggle.emit()">
        <div class="title-label">
            {{title}}
        </div>
        <label *ngIf="!active">+</label>
        <label *ngIf="active">-</label>
    </div>
    <div *ngIf="active">
        <ng-template [ngTemplateOutlet]="templateRef"></ng-template>
    </div>
</div>
